module.exports = __webpack_public_path__ + "assets/img/carousel_3.ce28bd94.png";